const { stableStringify } = require('../export/json');

function getTextEncoder() {
  if (typeof TextEncoder !== 'undefined') {
    return new TextEncoder();
  }

  const nodeRequire = eval('require');
  const { TextEncoder: NodeTextEncoder } = nodeRequire('util');
  return new NodeTextEncoder();
}

function getSubtleCrypto() {
  if (globalThis.crypto && globalThis.crypto.subtle) {
    return globalThis.crypto.subtle;
  }

  const nodeRequire = eval('require');
  return nodeRequire('crypto').webcrypto.subtle;
}

async function sha256Hex(input) {
  const digest = await getSubtleCrypto().digest('SHA-256', getTextEncoder().encode(String(input)));
  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
}

async function hmacSha256Hex(secret, input) {
  const encoder = getTextEncoder();
  const key = await getSubtleCrypto().importKey(
    'raw',
    encoder.encode(String(secret)),
    { name: 'HMAC', hash: 'SHA-256' },
    false,
    ['sign']
  );
  const signature = await getSubtleCrypto().sign('HMAC', key, encoder.encode(String(input)));
  return Array.from(new Uint8Array(signature))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
}

function canonicalize(value) {
  return stableStringify(value);
}

module.exports = {
  canonicalize,
  hmacSha256Hex,
  sha256Hex
};
